import styled from "styled-components";

export const Input = styled.input`
    text-align: center;
    width: 100%;
    border: none;
    background: transparent;
    font-size: ${globalThis.config.fonts.sizes.small};
    font-family: ${globalThis.config.fonts.families.bold};
    -moz-appearance: textfield;
    padding: 0;
    margin: 0;
    user-select: none;
    cursor: pointer;
    color: ${(props) => props.$color};

    &:focus {
        outline: none;
        user-select: none;
    }
`;

export const Text = styled.span`
    font-size: ${globalThis.config.fonts.sizes.small};
    font-family: ${globalThis.config.fonts.families.bold};
`;
